import { createSlice } from "@reduxjs/toolkit";
import {
  getSalesEquityReport,
  getSalesPartnerList,
  getSalesClientList,
  getSalesNetworkList,
  getSalesMoneyTransferList,
} from "./thunk";

export const initialState = {
  // Get Sales Partner List
  salesPartnerList: [],
  isSalesPartnerListSuccess: false,
  getSalesPartnerListLoading: false,
  // Get Sales Retail List
  salesRetailList: [],
  isSalesRetailListSuccess: false,
  getSalesClientListLoading: false,
  // Get Sales Network List
  salesNetworkList: [],
  isSalesNetworkListSuccess: false,
  getSalesNetworkListLoading: false,
  // Get Sales Money Transfer Report
  salesMoneyTransfers: [],
  isListSalesMoneyTransfersSuccess: false,
  getSalesMoneyTransferListLoading: false,
  // Get Sales Equity Report
  salesEquityReports: [],
  isListSalesEquityReportsSuccess: false,
  getSalesEquityReportLoading: false,
  // Error Handling
  error: {},
};

const ReportSlice = createSlice({
  name: "ReportSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get Sales Partner List
    builder.addCase(getSalesPartnerList.pending, (state) => {
      state.getSalesPartnerListLoading = true;
      state.error = false;
    });
    builder.addCase(
      getSalesPartnerList.fulfilled,
      (state: any, action: any) => {
        state.salesPartnerList = action.payload;
        state.isSalesPartnerListSuccess = true;
        state.getSalesPartnerListLoading = false;
        state.error = false;
      }
    );
    builder.addCase(getSalesPartnerList.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
      state.getSalesPartnerListLoading = false;
    });
    // Get Sales Retail List
    builder.addCase(getSalesClientList.pending, (state) => {
      state.getSalesClientListLoading = true;
      state.error = false;
    });
    builder.addCase(getSalesClientList.fulfilled, (state: any, action: any) => {
      state.salesRetailList = action.payload;
      state.isSalesRetailListSuccess = true;
      state.getSalesClientListLoading = false;
      state.error = false;
    });
    builder.addCase(getSalesClientList.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
      state.getSalesClientListLoading = false;
    });
    // Get Sales Network List
    builder.addCase(getSalesNetworkList.pending, (state) => {
      state.getSalesNetworkListLoading = true;
      state.error = false;
    });
    builder.addCase(
      getSalesNetworkList.fulfilled,
      (state: any, action: any) => {
        state.salesNetworkList = action.payload;
        state.isSalesNetworkListSuccess = true;
        state.getSalesNetworkListLoading = false;
        state.error = false;
      }
    );
    builder.addCase(getSalesNetworkList.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
      state.getSalesNetworkListLoading = false;
    });
    // Get Sales Money Transfer Report
    builder.addCase(getSalesMoneyTransferList.pending, (state) => {
      state.getSalesMoneyTransferListLoading = true;
      state.error = false;
    });
    builder.addCase(
      getSalesMoneyTransferList.fulfilled,
      (state: any, action: any) => {
        state.salesMoneyTransfers = action.payload;
        state.isListSalesMoneyTransfersSuccess = true;
        state.getSalesMoneyTransferListLoading = false;
        state.error = false;
      }
    );
    builder.addCase(
      getSalesMoneyTransferList.rejected,
      (state: any, action: any) => {
        state.error = action.payload || null;
        state.getSalesMoneyTransferListLoading = false;
      }
    );
    // Get Sales Equity Report
    builder.addCase(getSalesEquityReport.pending, (state) => {
      state.getSalesEquityReportLoading = true;
      state.error = false;
    });
    builder.addCase(
      getSalesEquityReport.fulfilled,
      (state: any, action: any) => {
        state.salesEquityReports = action.payload;
        state.isListSalesEquityReportsSuccess = true;
        state.getSalesEquityReportLoading = false;
        state.error = false;
      }
    );
    builder.addCase(
      getSalesEquityReport.rejected,
      (state: any, action: any) => {
        state.error = action.payload || null;
        state.getSalesEquityReportLoading = false;
      }
    );
  },
});

export default ReportSlice.reducer;
